export const Data = [
  {
    id: 1,
    title: "Темный шоколад/апельсин",
    info: "темный шоколад, шоколад со вкусом апельсина, какао-масло, сливки натуральные «Петмол» 33% , масло сливочное «Экомилк», сироп глюкозный, инвертный сироп",
  },
  {
    id: 2,
    title: "Трюфель классический в обсыпке какао",
    info: "темный шоколад, шоколад со вкусом апельсина, какао-масло, сливки натуральные «Петмол» 33% , масло сливочное «Экомилк», сироп глюкозный, инвертный сиропй",
  },
  {
    id: 3,
    title:
      "Трюфель «Клубника в молочном шоколаде с ликером «Baileys Strawberries & Cream»",
    info: "молочный шоколад, какао-масло, пюре клубники, ликер «Baileys Strawberries & Cream», «Петмол» 33% , масло сливочное «Экомилк», сироп глюкозный, инвертный сироп",
  },
  {
    id: 4,
    title: "Медовый аромат",
    info: "Белый шоколад, какао-масло, цветы липы, мед натуральный липовый, сливки натуральные «Петмол» 33% , масло сливочное «Экомилк», сироп глюкозный, инвертный сироп",
  },
  {
    id: 5,
    title: "Темный шоколад с клубникой",
    info: "темный шоколад, клубника сублимированная, какао-масло, сливки натуральные «Петмол» 33% , масло сливочное «Экомилк», сироп глюкозный, инвертный сироп",
  },
  {
    id: 6,
    title: "Фисташка с Амаретто",
    info: "Белый шоколад, фисташковая паста, Амаретто, какао-масло, сливки натуральные «Петмол» 33% , масло сливочное «Экомилк», сироп глюкозный, инвертный сироп",
  },
  {
    id: 7,
    title: "Нежная мята",
    info: "молочный шоколад, темный шоколад, какао-масло, мята, паста мятная, сливки натуральные «Петмол» 33% , масло сливочное «Экомилк», сироп глюкозный, инвертный сироп, сироп глюкозный, инвертный сироп",
  },
];
